import styled from "@emotion/styled"

const ArticleAuthorInfoWrapper = styled.div`
  position: relative;
`

export default ArticleAuthorInfoWrapper
